import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import vid from '../assets/vid.mp4';
import poster from '../assets/hero-poster-v2.jpg';

const HeroSection = () => {
  const { t } = useTranslation();
  const videoRef = useRef(null);
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return undefined;
    const reveal = () => setVideoReady(true);
    video.addEventListener('playing', reveal, { once: true });
    return () => video.removeEventListener('playing', reveal);
  }, []);

  return (
    <section className="hero-section" aria-labelledby="hero-title">
      <img className="hero-poster" src={poster} alt="" aria-hidden="true" />
      <video
        ref={videoRef}
        className={`background-video ${videoReady ? 'is-ready' : ''}`}
        autoPlay loop muted playsInline controls={false} preload="auto" poster={poster}
      >
        <source src={vid} type="video/mp4" />
      </video>
      <div className="overlay" />
      <div className="content">
        <h1 id="hero-title">{t('hero.title')}</h1>
        <p>{t('hero.subtitle')}</p>
      </div>
      <style jsx>{`
        .hero-section { position: relative; min-height: 100svh; display: flex; align-items: center; overflow: hidden; background: #101a2b; }
        .background-video, .hero-poster { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
        .hero-poster { z-index: 0; transform: scale(1.01); }
        .background-video { z-index: 1; opacity: 0; transition: opacity 900ms cubic-bezier(0.16, 1, 0.3, 1); }
        .background-video.is-ready { opacity: 1; }
        .overlay { position: absolute; inset: 0; z-index: 2; background: linear-gradient(90deg, rgba(8,17,31,.88) 0%, rgba(8,17,31,.58) 50%, rgba(8,17,31,.18) 100%); }
        .content { position: relative; z-index: 3; width: min(1200px, calc(100% - 2.5rem)); margin: 0 auto; padding-top: 5rem; color: white; }
        h1 { max-width: 10ch; margin: 0 0 1.25rem; font-size: clamp(3rem, 7vw, 5.75rem); font-weight: 700; line-height: .98; letter-spacing: -.035em; }
        p { max-width: 36ch; margin: 0; font-size: clamp(1.05rem, 1.7vw, 1.35rem); line-height: 1.5; color: rgba(255,255,255,.92); }
        @media (max-width: 640px) { .overlay { background: linear-gradient(180deg, rgba(8,17,31,.34), rgba(8,17,31,.86)); } .content { align-self: flex-end; padding-bottom: 5rem; } }
        @media (prefers-reduced-motion: reduce) { .background-video { display: none; } }
      `}</style>
    </section>
  );
};

export default HeroSection;
